const extractErrorLocation = (stack: string | undefined): string => {
  if (!stack) return "Unknown location";
  const match = stack.match(/(?:at\s+.*\()?(.*):(\d+):(\d+)\)?/); // Improved regex
  return match ? `File: ${match[1]}, Line: ${match[2]}` : "Location not found";
};

export const logError = async (error: Error, user?: string) => {
  const errUser = user || "Unknown user";
  const error_location = extractErrorLocation(error.stack);
  const error_message = `User: ${errUser}, Error: ${error.message}`;

  try {
    const logData = { error_message, error_location };

    const [response1, response2] = await Promise.all([
      fetch("/api/slack-log", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(logData),
      }),
      fetch("/api/backend-log", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(logData), // Now includes user info
      }),
    ]);

    if (!response1.ok || !response2.ok) {
      console.error("Error logging failed", { response1, response2 });
    }
  } catch (err) {
    console.error("Failed to send error logs:", err);
  }
};
